import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

export default function Rejected() {
  return (
    <div>
      <br />
      <Typography color="textSecondary" align="center">
        The administrators of the directory you registered for have 
        decided that it is not in the best interest of the security
        and privicy of the current users data that your account be
        given access. This decision is left up to the administrators 
        of the directory as stewarts of the security and privicy of
        their users. 

        If you feel this is a mistake, please contact the administrators directly.
        
        Thank you.
      </Typography>
      <br />
      <Button
        onClick={() => window.location = '/signin'}
        variant="contained"
        color="primary"
      >
        Back
      </Button>
    </div>
  );
}